import { createAction, props } from '@ngrx/store';
import { WsMessage } from '../../services/ws.service';

export const wsConnected = createAction('[WS] Connected');
export const wsDisconnected = createAction(
  '[WS] Disconnected',
  props<{ event: CloseEvent }>()
);
export const wsMessageReceived = createAction(
  '[WS] Message Received',
  props<{ message: WsMessage }>()
);
export const wsEventReceived = createAction(
  '[WS] Event Received',
  props<{ message: WsMessage }>()
);


export const newCommentReceived = createAction(
  '[WS] New Comment Received',
  props<{ comment: any; topic: string }>()
);
export const updateSiteReceived = createAction(
  '[WS] Update Site Received',
  props<{ site: any; topic: string }>()
);
export const updateDifferentialTilesetReceived = createAction(
  '[WS] Update Differential Tileset Received',
  props<{ differentialTileset: any; topic: string }>()
);
export const siteStructureStopReceived = createAction(
  '[WS] Site Structure Stop Received',
  props<{ site: any; topic: string }>()
);
export const siteStructureErrorReceived = createAction(
  '[WS] Site Structure Error Received',
  props<{ site: any; topic: string }>()
);
export const warnStructureBeforeStopReceived = createAction(
  '[WS] Warn Structure Before Stop Received',
  props<{ topic: string }>()
);
